import { Application, Container } from 'pixi.js';

/**
 * Client-only service for PixiJS references.
 * Extracted from state.data.app and state.data.stage.
 */
export class RenderService {
  /**
   * The PixiJS Application instance.
   */
  public app: Application | undefined;

  /**
   * The main world container (stage).
   */
  public stage: Container | undefined;

  /**
   * Initialize the service with PixiJS references.
   */
  public initialize(app: Application, stage: Container): void {
    this.app = app;
    this.stage = stage;
  }

  /**
   * Check if the service is initialized.
   */
  public isInitialized(): boolean {
    return this.app !== undefined && this.stage !== undefined;
  }

  /**
   * Reset the service (for testing).
   */
  public reset(): void {
    this.app = undefined;
    this.stage = undefined;
  }
}
